import { UpdateMessageSetV2, UpdateMessageSetV2Variables } from './__generated__/UpdateMessageSetV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateMessageSetV2($input: UpdateMessageSetInputV2!) {
    updateMessageSet: updateMessageSetV2(input: $input) {
      __typename
      ... on MessageSetV2 {
        id
        title
        public
        dynamic
        rssUrl
        isNote
        messages {
          id
          text
          characters
          cardSize
        }
      }
      ... on MessageSetErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateMessageSet = () => useMutation<UpdateMessageSetV2, UpdateMessageSetV2Variables>(MUTATION)
